export default "__VITE_ASSET__DAOMXMt0__ 400w, __VITE_ASSET__DmCk4Zac__ 800w, __VITE_ASSET__BGDee5h6__ 1024w";